module.exports = __webpack_public_path__ + "static/img/30018 (1).5b20371.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30018 (1).webp
// module id = Lzzm
// module chunks = 14